/**
 *
 *
 */
import PButton from './PButton';
export default class ModeButton extends PIXI.Sprite {
    constructor() {
        super();
        this.fixedW = 16;
        this.fixedH = 12;
        this._mode = "video";
        this.interactive = true;

        this.bg = new PIXI.Graphics();
        this.addChild(this.bg);

        this.texturesStep = ["track_animation1_normal", "track_animation1_hover", "track_animation1_click"];
        this.texturesAudio = ["track_audio_normal", "track_audio_hover", "track_audio_click"];
        this.btn = new PButton(this.texturesStep);
        this.addChild(this.btn);
    }

    set mode(mode) {
        this._mode = mode;
        if(mode == "audio") {
            this.btn.setTextures(this.texturesAudio);
        }else {
            this.btn.setTextures(this.texturesStep);
        }
    }

    get mode() {
        return this._mode;
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/ModeButton.js